import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=5c8160fe&"
import script from "./PackageItem.vue?vue&type=script&lang=js&"
export * from "./PackageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports